(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-community-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moda-homepage-extras')) {
    customElements.define('moda-homepage-extras', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.root = this.closest('.mc-home');
        if (!this.root) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 700px)');
        this.cards = [...this.querySelectorAll('.mc-community-card')];
        this.nav = this.root.querySelector('.section-nav');
        this.links = [...this.nav.querySelectorAll('a[href^="#"]')];
        this.sections = this.links.map(link => this.root.querySelector(link.getAttribute('href'))).filter(Boolean);
        this.stats = [...this.root.querySelectorAll('.scale dt')];
        this.shortcuts = this.querySelector('.mc-mobile-shortcuts');
        this.hero = this.root.querySelector('.hero');
        this.pendingCards = new Set();
        this.statFrames = new Map();
        this.onScroll = () => {
          clearTimeout(this.idleTimer);
          this.idleTimer = setTimeout(() => this.revealPending(), 160);
          this.schedulePosition();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.signal });
        window.addEventListener('resize', () => this.schedulePosition(), { passive: true, signal: this.signal });
        this.reduced.addEventListener('change', () => this.configureMotion(), { signal: this.signal });
        this.mobile.addEventListener('change', () => this.updatePosition(), { signal: this.signal });
        document.addEventListener('mc-preview-options', () => this.updatePosition(), { signal: this.signal });
        this.root.addEventListener('mc-hero-motion-pause', event => {
          this.paused = Boolean(event.detail?.paused);
          if (this.paused) {
            this.cards.forEach(card => this.revealCard(card));
            this.finishStats();
            this.root.classList.remove('mc-precision-motion');
          }
        }, { signal: this.signal });
        this.cards.forEach(card => {
          card.addEventListener('pointerenter', () => this.revealCard(card), { signal: this.signal });
          card.addEventListener('focusin', () => this.revealCard(card), { signal: this.signal });
        });
        this.links.forEach(link => link.addEventListener('click', event => {
          const target = this.root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: this.motionAllowed() ? 'smooth' : 'instant', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        }, { signal: this.signal }));
        this.configureMotion();
        this.updatePosition();
      }
      motionAllowed() {
        return this.root.dataset.motion === 'true' && !this.reduced.matches && !this.paused;
      }
      configureMotion() {
        this.cardObserver?.disconnect();
        this.statObserver?.disconnect();
        this.lineObserver?.disconnect();
        this.classList.remove('mc-cards-motion');
        this.root.classList.remove('mc-precision-motion');
        this.finishStats();
        if (!this.motionAllowed() || !('IntersectionObserver' in window)) {
          this.cards.forEach(card => this.revealCard(card));
          return;
        }
        this.classList.add('mc-cards-motion');
        this.root.classList.add('mc-precision-motion');
        this.cardObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.pendingCards.add(entry.target);
            else this.pendingCards.delete(entry.target);
          });
          clearTimeout(this.idleTimer);
          this.idleTimer = setTimeout(() => this.revealPending(), 160);
        }, { threshold: .32 });
        this.cards.filter(card => !card.hasAttribute('data-description-visible')).forEach(card => this.cardObserver.observe(card));
        this.statObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.animateStat(entry.target);
            this.statObserver.unobserve(entry.target);
          });
        }, { threshold: .8 });
        this.stats.forEach(stat => this.statObserver.observe(stat));
        this.lineObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-line-visible', '');
            this.lineObserver.unobserve(entry.target);
          });
        }, { threshold: .5 });
        this.root.querySelectorAll('.mc-precision-rule').forEach(line => this.lineObserver.observe(line));
      }
      revealPending() {
        this.pendingCards.forEach(card => this.revealCard(card));
        this.pendingCards.clear();
      }
      revealCard(card) {
        card.setAttribute('data-description-visible', '');
        this.pendingCards.delete(card);
        this.cardObserver?.unobserve(card);
      }
      animateStat(stat) {
        if (stat.dataset.counted) return;
        stat.dataset.counted = 'true';
        const final = stat.textContent.trim();
        const value = Number(final.replace(/[^0-9]/g, ''));
        if (!Number.isFinite(value) || !value) return;
        const suffix = final.endsWith('+') ? '+' : '';
        const accessible = document.createElement('span');
        accessible.className = 'mc-stat-a11y';
        accessible.textContent = final;
        const reserved = document.createElement('span');
        reserved.className = 'mc-stat-final';
        reserved.setAttribute('aria-hidden', 'true');
        reserved.textContent = final;
        const visible = document.createElement('span');
        visible.className = 'mc-stat-visible';
        visible.setAttribute('aria-hidden', 'true');
        visible.textContent = final;
        stat.replaceChildren(accessible, reserved, visible);
        const start = performance.now();
        const frame = now => {
          const progress = Math.min((now - start) / 1250, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          visible.textContent = Math.round(value * eased).toLocaleString('en-US') + suffix;
          if (progress < 1 && this.motionAllowed()) this.statFrames.set(stat, requestAnimationFrame(frame));
          else {
            visible.textContent = final;
            this.statFrames.delete(stat);
          }
        };
        this.statFrames.set(stat, requestAnimationFrame(frame));
      }
      finishStats() {
        this.statFrames?.forEach((frame, stat) => {
          cancelAnimationFrame(frame);
          const final = stat.querySelector('.mc-stat-final');
          const visible = stat.querySelector('.mc-stat-visible');
          if (final && visible) visible.textContent = final.textContent;
        });
        this.statFrames?.clear();
      }
      schedulePosition() {
        if (this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = null;
          this.updatePosition();
        });
      }
      updatePosition() {
        const cutoff = this.nav.getBoundingClientRect().height + 100;
        let active = this.sections[0];
        this.sections.forEach(section => {
          if (section.getBoundingClientRect().top <= cutoff) active = section;
        });
        this.links.forEach(link => {
          if (link.getAttribute('href') === '#' + active?.id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const show = document.body.dataset.shortcuts === 'on' && this.mobile.matches && this.hero.getBoundingClientRect().bottom <= this.nav.getBoundingClientRect().height;
        this.shortcuts.hidden = !show;
        this.shortcuts.inert = !show;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.cardObserver?.disconnect();
        this.statObserver?.disconnect();
        this.lineObserver?.disconnect();
        this.finishStats();
        clearTimeout(this.idleTimer);
        cancelAnimationFrame(this.positionFrame);
        this.root?.classList.remove('mc-precision-motion');
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-hero-text-reveal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moda-hero-text-reveal')) {
    customElements.define('moda-hero-text-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.root = this.closest('.mc-home');
        if (!this.root) return;
        const heading = this.root.querySelector('#mc-hero-heading');
        const subheading = this.root.querySelector('#mc-hero-subheading');
        if (!heading || !subheading) return;
        this.controller = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.targets = [heading, subheading].map(element => {
          const text = element.textContent;
          const words = text.trim().split(/\s+/);
          const readable = document.createElement('span');
          readable.className = 'mc-text-reveal-readable';
          readable.textContent = text;
          const visual = document.createElement('span');
          visual.setAttribute('aria-hidden', 'true');
          visual.style.setProperty('--mc-word-count', words.length);
          words.forEach((word, index) => {
            if (index) visual.append(document.createTextNode(' '));
            const span = document.createElement('span');
            span.className = 'mc-text-reveal-word';
            span.dataset.word = word;
            span.style.setProperty('--mc-word-index', index);
            span.textContent = word;
            visual.append(span);
          });
          element.replaceChildren(readable, visual);
          return { element, visual, text };
        });
        this.setProgress = progress => {
          this.targets.forEach((target, index) => {
            target.visual.style.setProperty('--mc-reveal-amount', Math.min(1, Math.max(0, progress[index])));
          });
        };
        this.draw = () => {
          this.frame = null;
          if (this.pausedAt != null) return;
          const elapsed = Math.max(0, document.timeline.currentTime - this.startedAt);
          this.setProgress([elapsed / 1450, (elapsed - 650) / 1550]);
          if (elapsed < 2200) this.frame = requestAnimationFrame(this.draw);
        };
        this.replay = event => {
          if (this.frame != null) cancelAnimationFrame(this.frame);
          this.pausedAt = null;
          this.manualPause = false;
          if (this.reduced.matches || this.root.dataset.motion === 'false') {
            this.setProgress([1, 1]);
            return;
          }
          this.startedAt = event.detail?.startedAt ?? document.timeline.currentTime;
          this.setProgress([0, 0]);
          this.draw();
        };
        this.pause = paused => {
          if (this.startedAt == null) return;
          if (paused && this.pausedAt == null) {
            this.pausedAt = document.timeline.currentTime;
            if (this.frame != null) cancelAnimationFrame(this.frame);
            this.frame = null;
          } else if (!paused && this.pausedAt != null) {
            this.startedAt += document.timeline.currentTime - this.pausedAt;
            this.pausedAt = null;
            this.draw();
          }
        };
        this.startTogether = () => {
          this.root.dispatchEvent(new CustomEvent('mc-hero-motion-replay', {
            detail: { startedAt: document.timeline.currentTime }
          }));
        };
        const { signal } = this.controller;
        this.root.addEventListener('mc-hero-motion-replay', this.replay, { signal });
        this.root.addEventListener('mc-hero-motion-pause', event => {
          this.manualPause = event.detail.paused;
          this.pause(this.manualPause || document.hidden);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.pause(this.manualPause || document.hidden), { signal });
        this.reduced.addEventListener('change', this.startTogether, { signal });
        this.settingsObserver = new MutationObserver(this.startTogether);
        this.settingsObserver.observe(this.root, { attributes: true, attributeFilter: ['data-motion'] });
        this.setProgress([0, 0]);
        const imageURL = this.root.querySelector('.mc-watch-logo')?.getAttribute('href');
        const imageReady = imageURL ? (() => {
          const image = new Image();
          image.src = imageURL;
          return image.decode().catch(() => {});
        })() : Promise.resolve();
        Promise.all([document.fonts.ready, imageReady, customElements.whenDefined('moda-clubs-watch-sign')]).then(() => {
          if (signal.aborted) return;
          this.startTogether();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.settingsObserver?.disconnect();
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.targets?.forEach(({ element, text }) => element.replaceChildren(document.createTextNode(text)));
        this.targets = null;
        this.controller = null;
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-welcome-panels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moda-community-panel')) {
    customElements.define('moda-community-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.desktop = matchMedia('(min-width: 900px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.items = [...this.querySelectorAll('[data-panel-item]')];
        this.headings = this.items.map(item => item.querySelector('h3'));
        this.links = this.items.map(item => item.querySelector('a'));
        this.panel = this.querySelector('.mc-panel-media');
        this.media = this.items.map((item, index) => {
          const copy = item.querySelector('figure').cloneNode(true);
          copy.removeAttribute('id');
          const link = document.createElement('a');
          link.href = this.links[index].href;
          link.className = 'mc-panel-photo-link';
          link.setAttribute('aria-label', this.links[index].textContent.trim());
          link.hidden = true;
          link.append(copy);
          this.panel.append(link);
          return link;
        });
        this.classList.add('mc-panel-ready');
        this.panel.hidden = false;
        this.items.forEach((item, index) => {
          const preview = () => {
            this.lockUntil = performance.now() + 1000;
            this.activate(index, true);
          };
          item.addEventListener('pointerenter', preview, { signal });
          item.addEventListener('focusin', preview, { signal });
        });
        window.addEventListener('scroll', () => {
          clearTimeout(this.idle);
          this.idle = setTimeout(() => {
            if (!this.desktop.matches || performance.now() < (this.lockUntil || 0)) return;
            const rect = this.getBoundingClientRect();
            if (rect.bottom < 100 || rect.top > innerHeight * .7) return;
            const target = innerHeight * .38;
            const closest = this.items.reduce((best, item, index) => {
              const bounds = item.getBoundingClientRect();
              const distance = Math.abs(bounds.top + bounds.height / 2 - target);
              return distance < best.distance ? { distance, index } : best;
            }, { distance: Infinity, index: this.active || 0 });
            this.activate(closest.index, true);
          }, 160);
        }, { passive: true, signal });
        this.desktop.addEventListener('change', () => this.activate(this.active || 0, false), { signal });
        this.activate(0, false);
      }
      activate(index, animate) {
        const changed = this.active !== index;
        this.active = index;
        this.items.forEach((item, position) => {
          item.toggleAttribute('data-active', position === index);
          this.media[position].hidden = position !== index;
        });
        this.panel.setAttribute('aria-labelledby', this.headings[index].id);
        if (changed && animate && !this.reduced.matches && this.closest('.mc-home')?.dataset.motion !== 'false') {
          const figure = this.desktop.matches ? this.media[index] : this.items[index].querySelector('figure');
          figure.animate([{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 350, easing: 'ease-out' });
        }
      }
      disconnectedCallback() {
        clearTimeout(this.idle);
        this.controller?.abort();
        this.panel?.replaceChildren();
        this.classList.remove('mc-panel-ready');
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
